/** @see https://gist.github.com/eduardolat/b2a252d17b17363fab0974bb0634d259 */
export default [
  {
    name: 'Afganistán',
    iso: 'AFG',
    phoneCode: '93',
  },
  {
    name: 'Albania',
    iso: 'ALB',
    phoneCode: '355',
  },
  {
    name: 'Alemania',
    iso: 'DEU',
    phoneCode: '49',
  },
  {
    name: 'Andorra',
    iso: 'AND',
    phoneCode: '376',
  },
  {
    name: 'Angola',
    iso: 'AGO',
    phoneCode: '244',
  },
  {
    name: 'Anguila',
    iso: 'AIA',
    phoneCode: '1 264',
  },
  {
    name: 'Antártida',
    iso: 'ATA',
    phoneCode: '672',
  },
  {
    name: 'Antigua y Barbuda',
    iso: 'ATG',
    phoneCode: '1 268',
  },
  {
    name: 'Arabia Saudita',
    iso: 'SAU',
    phoneCode: '966',
  },
  {
    name: 'Argelia',
    iso: 'DZA',
    phoneCode: '213',
  },
  {
    name: 'Argentina',
    iso: 'ARG',
    phoneCode: '54',
  },
  {
    name: 'Armenia',
    iso: 'ARM',
    phoneCode: '374',
  },
  {
    name: 'Aruba',
    iso: 'ABW',
    phoneCode: '297',
  },
  {
    name: 'Australia',
    iso: 'AUS',
    phoneCode: '61',
  },
  {
    name: 'Austria',
    iso: 'AUT',
    phoneCode: '43',
  },
  {
    name: 'Azerbaiyán',
    iso: 'AZE',
    phoneCode: '994',
  },
  {
    name: 'Bélgica',
    iso: 'BEL',
    phoneCode: '32',
  },
  {
    name: 'Bahamas',
    iso: 'BHS',
    phoneCode: '1 242',
  },
  {
    name: 'Bahrein',
    iso: 'BHR',
    phoneCode: '973',
  },
  {
    name: 'Bangladesh',
    iso: 'BGD',
    phoneCode: '880',
  },
  {
    name: 'Barbados',
    iso: 'BRB',
    phoneCode: '1 246',
  },
  {
    name: 'Belice',
    iso: 'BLZ',
    phoneCode: '501',
  },
  {
    name: 'Benín',
    iso: 'BEN',
    phoneCode: '229',
  },
  {
    name: 'Bhután',
    iso: 'BTN',
    phoneCode: '975',
  },
  {
    name: 'Bielorrusia',
    iso: 'BLR',
    phoneCode: '375',
  },
  {
    name: 'Birmania',
    iso: 'MMR',
    phoneCode: '95',
  },
  {
    name: 'Bolivia',
    iso: 'BOL',
    phoneCode: '591',
  },
  {
    name: 'Bosnia y Herzegovina',
    iso: 'BIH',
    phoneCode: '387',
  },
  {
    name: 'Botsuana',
    iso: 'BWA',
    phoneCode: '267',
  },
  {
    name: 'Brasil',
    iso: 'BRA',
    phoneCode: '55',
  },
  {
    name: 'Brunéi',
    iso: 'BRN',
    phoneCode: '673',
  },
  {
    name: 'Bulgaria',
    iso: 'BGR',
    phoneCode: '359',
  },
  {
    name: 'Burkina Faso',
    iso: 'BFA',
    phoneCode: '226',
  },
  {
    name: 'Burundi',
    iso: 'BDI',
    phoneCode: '257',
  },
  {
    name: 'Cabo Verde',
    iso: 'CPV',
    phoneCode: '238',
  },
  {
    name: 'Camboya',
    iso: 'KHM',
    phoneCode: '855',
  },
  {
    name: 'Camerún',
    iso: 'CMR',
    phoneCode: '237',
  },
  {
    name: 'Canadá',
    iso: 'CAN',
    phoneCode: '1',
  },
  {
    name: 'Chad',
    iso: 'TCD',
    phoneCode: '235',
  },
  {
    name: 'Chile',
    iso: 'CHL',
    phoneCode: '56',
  },
  {
    name: 'China',
    iso: 'CHN',
    phoneCode: '86',
  },
  {
    name: 'Chipre',
    iso: 'CYP',
    phoneCode: '357',
  },
  {
    name: 'Ciudad del Vaticano',
    iso: 'VAT',
    phoneCode: '39',
  },
  {
    name: 'Colombia',
    iso: 'COL',
    phoneCode: '57',
  },
  {
    name: 'Comoras',
    iso: 'COM',
    phoneCode: '269',
  },
  {
    name: 'República del Congo',
    iso: 'COG',
    phoneCode: '242',
  },
  {
    name: 'República Democrática del Congo',
    iso: 'COD',
    phoneCode: '243',
  },
  {
    name: 'Corea del Norte',
    iso: 'PRK',
    phoneCode: '850',
  },
  {
    name: 'Corea del Sur',
    iso: 'KOR',
    phoneCode: '82',
  },
  {
    name: 'Costa de Marfil',
    iso: 'CIV',
    phoneCode: '225',
  },
  {
    name: 'Costa Rica',
    iso: 'CRI',
    phoneCode: '506',
  },
  {
    name: 'Croacia',
    iso: 'HRV',
    phoneCode: '385',
  },
  {
    name: 'Cuba',
    iso: 'CUB',
    phoneCode: '53',
  },
  {
    name: 'Curazao',
    iso: 'CWU',
    phoneCode: '5999',
  },
  {
    name: 'Dinamarca',
    iso: 'DNK',
    phoneCode: '45',
  },
  {
    name: 'Dominica',
    iso: 'DMA',
    phoneCode: '1 767',
  },
  {
    name: 'Ecuador',
    iso: 'ECU',
    phoneCode: '593',
  },
  {
    name: 'Egipto',
    iso: 'EGY',
    phoneCode: '20',
  },
  {
    name: 'El Salvador',
    iso: 'SLV',
    phoneCode: '503',
  },
  {
    name: 'Emiratos Árabes Unidos',
    iso: 'ARE',
    phoneCode: '971',
  },
  {
    name: 'Eritrea',
    iso: 'ERI',
    phoneCode: '291',
  },
  {
    name: 'Eslovaquia',
    iso: 'SVK',
    phoneCode: '421',
  },
  {
    name: 'Eslovenia',
    iso: 'SVN',
    phoneCode: '386',
  },
  {
    name: 'España',
    iso: 'ESP',
    phoneCode: '34',
  },
  {
    name: 'Estados Unidos de América',
    iso: 'USA',
    phoneCode: '1',
  },
  {
    name: 'Estonia',
    iso: 'EST',
    phoneCode: '372',
  },
  {
    name: 'Etiopía',
    iso: 'ETH',
    phoneCode: '251',
  },
  {
    name: 'Filipinas',
    iso: 'PHL',
    phoneCode: '63',
  },
  {
    name: 'Finlandia',
    iso: 'FIN',
    phoneCode: '358',
  },
  {
    name: 'Fiyi',
    iso: 'FJI',
    phoneCode: '679',
  },
  {
    name: 'Francia',
    iso: 'FRA',
    phoneCode: '33',
  },
  {
    name: 'Gabón',
    iso: 'GAB',
    phoneCode: '241',
  },
  {
    name: 'Gambia',
    iso: 'GMB',
    phoneCode: '220',
  },
  {
    name: 'Georgia',
    iso: 'GEO',
    phoneCode: '995',
  },
  {
    name: 'Ghana',
    iso: 'GHA',
    phoneCode: '233',
  },
  {
    name: 'Gibraltar',
    iso: 'GIB',
    phoneCode: '350',
  },
  {
    name: 'Granada',
    iso: 'GRD',
    phoneCode: '1 473',
  },
  {
    name: 'Grecia',
    iso: 'GRC',
    phoneCode: '30',
  },
  {
    name: 'Groenlandia',
    iso: 'GRL',
    phoneCode: '299',
  },
  {
    name: 'Guadalupe',
    iso: 'GLP',
    phoneCode: '590',
  },
  {
    name: 'Guam',
    iso: 'GUM',
    phoneCode: '1 671',
  },
  {
    name: 'Guatemala',
    iso: 'GTM',
    phoneCode: '502',
  },
  {
    name: 'Guayana Francesa',
    iso: 'GUF',
    phoneCode: '594',
  },
  {
    name: 'Guernsey',
    iso: 'GGY',
    phoneCode: '44',
  },
  {
    name: 'Guinea',
    iso: 'GIN',
    phoneCode: '224',
  },
  {
    name: 'Guinea Ecuatorial',
    iso: 'GNQ',
    phoneCode: '240',
  },
  {
    name: 'Guinea-Bissau',
    iso: 'GNB',
    phoneCode: '245',
  },
  {
    name: 'Guyana',
    iso: 'GUY',
    phoneCode: '592',
  },
  {
    name: 'Haití',
    iso: 'HTI',
    phoneCode: '509',
  },
  {
    name: 'Honduras',
    iso: 'HND',
    phoneCode: '504',
  },
  {
    name: 'Hong kong',
    iso: 'HKG',
    phoneCode: '852',
  },
  {
    name: 'Hungría',
    iso: 'HUN',
    phoneCode: '36',
  },
  {
    name: 'India',
    iso: 'IND',
    phoneCode: '91',
  },
  {
    name: 'Indonesia',
    iso: 'IDN',
    phoneCode: '62',
  },
  {
    name: 'Irán',
    iso: 'IRN',
    phoneCode: '98',
  },
  {
    name: 'Irak',
    iso: 'IRQ',
    phoneCode: '964',
  },
  {
    name: 'Irlanda',
    iso: 'IRL',
    phoneCode: '353',
  },
  {
    name: 'Isla Bouvet',
    iso: 'BVT',
    phoneCode: '',
  },
  {
    name: 'Isla de Man',
    iso: 'IMN',
    phoneCode: '44',
  },
  {
    name: 'Isla de Navidad',
    iso: 'CXR',
    phoneCode: '61',
  },
  {
    name: 'Isla Norfolk',
    iso: 'NFK',
    phoneCode: '672',
  },
  {
    name: 'Islandia',
    iso: 'ISL',
    phoneCode: '354',
  },
  {
    name: 'Islas Bermudas',
    iso: 'BMU',
    phoneCode: '1 441',
  },
  {
    name: 'Islas Caimán',
    iso: 'CYM',
    phoneCode: '1 345',
  },
  {
    name: 'Islas Cocos (Keeling)',
    iso: 'CCK',
    phoneCode: '61',
  },
  {
    name: 'Islas Cook',
    iso: 'COK',
    phoneCode: '682',
  },
  {
    name: 'Islas de Åland',
    iso: 'ALA',
    phoneCode: '358',
  },
  {
    name: 'Islas Feroe',
    iso: 'FRO',
    phoneCode: '298',
  },
  {
    name: 'Islas Georgias del Sur y Sandwich del Sur',
    iso: 'SGS',
    phoneCode: '500',
  },
  {
    name: 'Islas Heard y McDonald',
    iso: 'HMD',
    phoneCode: '',
  },
  {
    name: 'Islas Maldivas',
    iso: 'MDV',
    phoneCode: '960',
  },
  {
    name: 'Islas Malvinas',
    iso: 'FLK',
    phoneCode: '500',
  },
  {
    name: 'Islas Marianas del Norte',
    iso: 'MNP',
    phoneCode: '1 670',
  },
  {
    name: 'Islas Marshall',
    iso: 'MHL',
    phoneCode: '692',
  },
  {
    name: 'Islas Pitcairn',
    iso: 'PCN',
    phoneCode: '870',
  },
  {
    name: 'Islas Salomón',
    iso: 'SLB',
    phoneCode: '677',
  },
  {
    name: 'Islas Turcas y Caicos',
    iso: 'TCA',
    phoneCode: '1 649',
  },
  {
    name: 'Islas Ultramarinas Menores de Estados Unidos',
    iso: 'UMI',
    phoneCode: '246',
  },
  {
    name: 'Islas Vírgenes Británicas',
    iso: 'VGB',
    phoneCode: '1 284',
  },
  {
    name: 'Islas Vírgenes de los Estados Unidos',
    iso: 'VIR',
    phoneCode: '1 340',
  },
  {
    name: 'Israel',
    iso: 'ISR',
    phoneCode: '972',
  },
  {
    name: 'Italia',
    iso: 'ITA',
    phoneCode: '39',
  },
  {
    name: 'Jamaica',
    iso: 'JAM',
    phoneCode: '1 876',
  },
  {
    name: 'Japón',
    iso: 'JPN',
    phoneCode: '81',
  },
  {
    name: 'Jersey',
    iso: 'JEY',
    phoneCode: '44',
  },
  {
    name: 'Jordania',
    iso: 'JOR',
    phoneCode: '962',
  },
  {
    name: 'Kazajistán',
    iso: 'KAZ',
    phoneCode: '7',
  },
  {
    name: 'Kenia',
    iso: 'KEN',
    phoneCode: '254',
  },
  {
    name: 'Kirguistán',
    iso: 'KGZ',
    phoneCode: '996',
  },
  {
    name: 'Kiribati',
    iso: 'KIR',
    phoneCode: '686',
  },
  {
    name: 'Kuwait',
    iso: 'KWT',
    phoneCode: '965',
  },
  {
    name: 'Líbano',
    iso: 'LBN',
    phoneCode: '961',
  },
  {
    name: 'Laos',
    iso: 'LAO',
    phoneCode: '856',
  },
  {
    name: 'Lesoto',
    iso: 'LSO',
    phoneCode: '266',
  },
  {
    name: 'Letonia',
    iso: 'LVA',
    phoneCode: '371',
  },
  {
    name: 'Liberia',
    iso: 'LBR',
    phoneCode: '231',
  },
  {
    name: 'Libia',
    iso: 'LBY',
    phoneCode: '218',
  },
  {
    name: 'Liechtenstein',
    iso: 'LIE',
    phoneCode: '423',
  },
  {
    name: 'Lituania',
    iso: 'LTU',
    phoneCode: '370',
  },
  {
    name: 'Luxemburgo',
    iso: 'LUX',
    phoneCode: '352',
  },
  {
    name: 'México',
    iso: 'MEX',
    phoneCode: '52',
  },
  {
    name: 'Mónaco',
    iso: 'MCO',
    phoneCode: '377',
  },
  {
    name: 'Macao',
    iso: 'MAC',
    phoneCode: '853',
  },
  {
    name: 'Macedônia',
    iso: 'MKD',
    phoneCode: '389',
  },
  {
    name: 'Madagascar',
    iso: 'MDG',
    phoneCode: '261',
  },
  {
    name: 'Malasia',
    iso: 'MYS',
    phoneCode: '60',
  },
  {
    name: 'Malawi',
    iso: 'MWI',
    phoneCode: '265',
  },
  {
    name: 'Mali',
    iso: 'MLI',
    phoneCode: '223',
  },
  {
    name: 'Malta',
    iso: 'MLT',
    phoneCode: '356',
  },
  {
    name: 'Marruecos',
    iso: 'MAR',
    phoneCode: '212',
  },
  {
    name: 'Martinica',
    iso: 'MTQ',
    phoneCode: '596',
  },
  {
    name: 'Mauricio',
    iso: 'MUS',
    phoneCode: '230',
  },
  {
    name: 'Mauritania',
    iso: 'MRT',
    phoneCode: '222',
  },
  {
    name: 'Mayotte',
    iso: 'MYT',
    phoneCode: '262',
  },
  {
    name: 'Micronesia',
    iso: 'FSM',
    phoneCode: '691',
  },
  {
    name: 'Moldavia',
    iso: 'MDA',
    phoneCode: '373',
  },
  {
    name: 'Mongolia',
    iso: 'MNG',
    phoneCode: '976',
  },
  {
    name: 'Montenegro',
    iso: 'MNE',
    phoneCode: '382',
  },
  {
    name: 'Montserrat',
    iso: 'MSR',
    phoneCode: '1 664',
  },
  {
    name: 'Mozambique',
    iso: 'MOZ',
    phoneCode: '258',
  },
  {
    name: 'Namibia',
    iso: 'NAM',
    phoneCode: '264',
  },
  {
    name: 'Nauru',
    iso: 'NRU',
    phoneCode: '674',
  },
  {
    name: 'Nepal',
    iso: 'NPL',
    phoneCode: '977',
  },
  {
    name: 'Nicaragua',
    iso: 'NIC',
    phoneCode: '505',
  },
  {
    name: 'Niger',
    iso: 'NER',
    phoneCode: '227',
  },
  {
    name: 'Nigeria',
    iso: 'NGA',
    phoneCode: '234',
  },
  {
    name: 'Niue',
    iso: 'NIU',
    phoneCode: '683',
  },
  {
    name: 'Noruega',
    iso: 'NOR',
    phoneCode: '47',
  },
  {
    name: 'Nueva Caledonia',
    iso: 'NCL',
    phoneCode: '687',
  },
  {
    name: 'Nueva Zelanda',
    iso: 'NZL',
    phoneCode: '64',
  },
  {
    name: 'Omán',
    iso: 'OMN',
    phoneCode: '968',
  },
  {
    name: 'Países Bajos',
    iso: 'NLD',
    phoneCode: '31',
  },
  {
    name: 'Pakistán',
    iso: 'PAK',
    phoneCode: '92',
  },
  {
    name: 'Palau',
    iso: 'PLW',
    phoneCode: '680',
  },
  {
    name: 'Palestina',
    iso: 'PSE',
    phoneCode: '970',
  },
  {
    name: 'Panamá',
    iso: 'PAN',
    phoneCode: '507',
  },
  {
    name: 'Papúa Nueva Guinea',
    iso: 'PNG',
    phoneCode: '675',
  },
  {
    name: 'Paraguay',
    iso: 'PRY',
    phoneCode: '595',
  },
  {
    name: 'Perú',
    iso: 'PER',
    phoneCode: '51',
  },
  {
    name: 'Polinesia Francesa',
    iso: 'PYF',
    phoneCode: '689',
  },
  {
    name: 'Polonia',
    iso: 'POL',
    phoneCode: '48',
  },
  {
    name: 'Portugal',
    iso: 'PRT',
    phoneCode: '351',
  },
  {
    name: 'Puerto Rico',
    iso: 'PRI',
    phoneCode: '1',
  },
  {
    name: 'Qatar',
    iso: 'QAT',
    phoneCode: '974',
  },
  {
    name: 'Reino Unido',
    iso: 'GBR',
    phoneCode: '44',
  },
  {
    name: 'República Centroafricana',
    iso: 'CAF',
    phoneCode: '236',
  },
  {
    name: 'República Checa',
    iso: 'CZE',
    phoneCode: '420',
  },
  {
    name: 'República Dominicana',
    iso: 'DOM',
    phoneCode: '1 809',
  },
  {
    name: 'República de Sudán del Sur',
    iso: 'SSD',
    phoneCode: '211',
  },
  {
    name: 'Reunión',
    iso: 'REU',
    phoneCode: '262',
  },
  {
    name: 'Ruanda',
    iso: 'RWA',
    phoneCode: '250',
  },
  {
    name: 'Rumanía',
    iso: 'ROU',
    phoneCode: '40',
  },
  {
    name: 'Rusia',
    iso: 'RUS',
    phoneCode: '7',
  },
  {
    name: 'Sahara Occidental',
    iso: 'ESH',
    phoneCode: '212',
  },
  {
    name: 'Samoa',
    iso: 'WSM',
    phoneCode: '685',
  },
  {
    name: 'Samoa Americana',
    iso: 'ASM',
    phoneCode: '1 684',
  },
  {
    name: 'San Bartolomé',
    iso: 'BLM',
    phoneCode: '590',
  },
  {
    name: 'San Cristóbal y Nieves',
    iso: 'KNA',
    phoneCode: '1 869',
  },
  {
    name: 'San Marino',
    iso: 'SMR',
    phoneCode: '378',
  },
  {
    name: 'San Martín (Francia)',
    iso: 'MAF',
    phoneCode: '1 599',
  },
  {
    name: 'San Pedro y Miquelón',
    iso: 'SPM',
    phoneCode: '508',
  },
  {
    name: 'San Vicente y las Granadinas',
    iso: 'VCT',
    phoneCode: '1 784',
  },
  {
    name: 'Santa Elena',
    iso: 'SHN',
    phoneCode: '290',
  },
  {
    name: 'Santa Lucía',
    iso: 'LCA',
    phoneCode: '1 758',
  },
  {
    name: 'Santo Tomé y Príncipe',
    iso: 'STP',
    phoneCode: '239',
  },
  {
    name: 'Senegal',
    iso: 'SEN',
    phoneCode: '221',
  },
  {
    name: 'Serbia',
    iso: 'SRB',
    phoneCode: '381',
  },
  {
    name: 'Seychelles',
    iso: 'SYC',
    phoneCode: '248',
  },
  {
    name: 'Sierra Leona',
    iso: 'SLE',
    phoneCode: '232',
  },
  {
    name: 'Singapur',
    iso: 'SGP',
    phoneCode: '65',
  },
  {
    name: 'Sint Maarten',
    iso: 'SMX',
    phoneCode: '1 721',
  },
  {
    name: 'Siria',
    iso: 'SYR',
    phoneCode: '963',
  },
  {
    name: 'Somalia',
    iso: 'SOM',
    phoneCode: '252',
  },
  {
    name: 'Sri lanka',
    iso: 'LKA',
    phoneCode: '94',
  },
  {
    name: 'Sudáfrica',
    iso: 'ZAF',
    phoneCode: '27',
  },
  {
    name: 'Sudán',
    iso: 'SDN',
    phoneCode: '249',
  },
  {
    name: 'Suecia',
    iso: 'SWE',
    phoneCode: '46',
  },
  {
    name: 'Suiza',
    iso: 'CHE',
    phoneCode: '41',
  },
  {
    name: 'Surinám',
    iso: 'SUR',
    phoneCode: '597',
  },
  {
    name: 'Svalbard y Jan Mayen',
    iso: 'SJM',
    phoneCode: '47',
  },
  {
    name: 'Swazilandia',
    iso: 'SWZ',
    phoneCode: '268',
  },
  {
    name: 'Tayikistán',
    iso: 'TJK',
    phoneCode: '992',
  },
  {
    name: 'Tailandia',
    iso: 'THA',
    phoneCode: '66',
  },
  {
    name: 'Taiwán',
    iso: 'TWN',
    phoneCode: '886',
  },
  {
    name: 'Tanzania',
    iso: 'TZA',
    phoneCode: '255',
  },
  {
    name: 'Territorio Británico del Océano Índico',
    iso: 'IOT',
    phoneCode: '246',
  },
  {
    name: 'Territorios Australes y Antárticas Franceses',
    iso: 'ATF',
    phoneCode: '',
  },
  {
    name: 'Timor Oriental',
    iso: 'TLS',
    phoneCode: '670',
  },
  {
    name: 'Togo',
    iso: 'TGO',
    phoneCode: '228',
  },
  {
    name: 'Tokelau',
    iso: 'TKL',
    phoneCode: '690',
  },
  {
    name: 'Tonga',
    iso: 'TON',
    phoneCode: '676',
  },
  {
    name: 'Trinidad y Tobago',
    iso: 'TTO',
    phoneCode: '1 868',
  },
  {
    name: 'Tunez',
    iso: 'TUN',
    phoneCode: '216',
  },
  {
    name: 'Turkmenistán',
    iso: 'TKM',
    phoneCode: '993',
  },
  {
    name: 'Turquía',
    iso: 'TUR',
    phoneCode: '90',
  },
  {
    name: 'Tuvalu',
    iso: 'TUV',
    phoneCode: '688',
  },
  {
    name: 'Ucrania',
    iso: 'UKR',
    phoneCode: '380',
  },
  {
    name: 'Uganda',
    iso: 'UGA',
    phoneCode: '256',
  },
  {
    name: 'Uruguay',
    iso: 'URY',
    phoneCode: '598',
  },
  {
    name: 'Uzbekistán',
    iso: 'UZB',
    phoneCode: '998',
  },
  {
    name: 'Vanuatu',
    iso: 'VUT',
    phoneCode: '678',
  },
  {
    name: 'Venezuela',
    iso: 'VEN',
    phoneCode: '58',
  },
  {
    name: 'Vietnam',
    iso: 'VNM',
    phoneCode: '84',
  },
  {
    name: 'Wallis y Futuna',
    iso: 'WLF',
    phoneCode: '681',
  },
  {
    name: 'Yemen',
    iso: 'YEM',
    phoneCode: '967',
  },
  {
    name: 'Yibuti',
    iso: 'DJI',
    phoneCode: '253',
  },
  {
    name: 'Zambia',
    iso: 'ZMB',
    phoneCode: '260',
  },
  {
    name: 'Zimbabue',
    iso: 'ZWE',
    phoneCode: '263',
  },
];
